import reassign from './reassign';
import add_contact from './add_contact';

export default {
  search: {
    title: 'Поиск',
    placeholder: 'Поиск сообщений',
  },
  resolved: {
    resolved: 'Отметить как решённый',
    unresolved: 'Отметить как нерешённый',
  },
  favorite: {
    favorite: 'Добавить в избранное',
    unfavorite: 'Убрать из избранного',
  },
  reassign,
  add_contact,
  export: {
    title: 'Загрузить историю',
  },
}
